import { Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

const ButtonWithTrackEvent = withTrackEvent(Button);

interface ButtonToRequestDirectoryCsvProps {
  isCsvGenerationInProgress: boolean;
  onClick: () => void;
}

export const ButtonToRequestDirectoryCsv = ({
  isCsvGenerationInProgress,
  onClick,
}: ButtonToRequestDirectoryCsvProps) => {
  return (
    <ButtonWithTrackEvent
      actionName={actionNames.download}
      actionPrefix={actionPrefixes.initiate}
      dataProps={{
        "data-qa-selector": "admin-console-generate-directory-button",
      }}
      flavor={Button.flavors.secondary}
      objectType={objectTypes.report}
      onClick={onClick}
      streamProperties={{
        description: "Generate directory csv file.",
      }}
    >
      {isCsvGenerationInProgress
        ? "Generating csv file..."
        : "Generate directory csv file"}
    </ButtonWithTrackEvent>
  );
};

export default ButtonToRequestDirectoryCsv;
